import { Card, CardTitle, Separator } from '@repo/shadcn';

import { useCreateType } from './create-type.hook';
import { TypeForm } from './type.form';

export const UpdateTypeModal = () => {
    const { isLoading, onSubmit } = useCreateType();

    return (
        <Card className="border-none shadow-none">
            <CardTitle className="mb-2 text-[18px]">Update Type</CardTitle>
            <Separator />
            <TypeForm
                isLoading={isLoading}
                onSubmit={onSubmit}
                initialValues={{ name: '' }}
            />
        </Card>
    );
};
